import styled from '@emotion/styled'
import { ButtonHTMLAttributes } from 'react'
import { useNavigate } from 'react-router-dom'

interface WrapperProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isSelected: boolean
}
const WrapperButton = styled.button<WrapperProps>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  background-color: var(--Transparent);
  display: flex;
  cursor: pointer;
  font-size: 16px;
  color: ${props => (props.isSelected ? 'inherit' : 'var(--White60)')};
  transition: background 0.1s ease;
  border-radius: 4px 4px 0 0;
  &:hover,
  &:focus {
    background: var(--White96);
    color: ${props => (props.isSelected ? 'inherit' : 'var(--White40)')};
  }
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    width: 100%;
    width: calc(100% - 24px);
    margin-left: 12px;
    background-color: ${props => (props.isSelected ? 'black' : 'none')};
  }
`

interface BorderProps {
  isSelected: boolean
}
const Border = styled.div<BorderProps>``

interface Props extends WrapperProps {
  to?: string
  value: string
}

export const Tab = ({ children, isSelected, onClick, to, value, ...props }: Props) => {
  const navigate = useNavigate()
  return (
    <WrapperButton
      {...props}
      aria-controls={`${value}-panel`}
      aria-selected={isSelected}
      id={`${value}-tab`}
      isSelected={isSelected}
      role="tab"
      onClick={to ? () => navigate(to) : onClick}
    >
      {children}
      <Border aria-hidden="true" isSelected={isSelected} />
    </WrapperButton>
  )
}
